/**
 * Класс авторизации клиентов психологического центра
 * SMS-авторизация через 4-значный код
 */
const Auth = {
	// ID модуля авторизации (из БД modules)
	moduleId: 3,

	// ID модуля профиля
	profileModuleId: 4,

	// Текущий номер телефона
	currentPhone: '',

	// Текущий email (в режиме отправки кода на email)
	currentEmail: '',

	// Канал отправки кода: sms | email
	codeChannel: 'sms',

	// Таймер для повторной отправки
	countdownTimer: null,
	countdownValue: 60,

	// Callback после успешной авторизации (для booking и др.)
	onAuthSuccessCallback: null,

	/**
	 * Инициализация
	 */
	init: function() {
		// Инициализация полей ввода кода
		this.initCodeInputs();

		// Обработчики закрытия попапов
		this.initPopupClose();

		// Авторизация теперь рендерится на сервере через setTplVar
		// this.checkAuth();

		// Маска для телефона
		this.initPhoneMask();
	},

	/**
	 * Маска для ввода телефона
	 */
	initPhoneMask: function() {
		const phoneInput = document.getElementById('auth-phone');
		if (!phoneInput) return;

		phoneInput.addEventListener('input', function(e) {
			let value = e.target.value.replace(/\D/g, '');

			// Ограничиваем 10 цифрами (без кода страны)
			if (value.length > 10) {
				value = value.slice(0, 10);
			}

			// Форматируем
			let formatted = '';
			if (value.length > 0) {
				formatted = '(' + value.substring(0, 3);
			}
			if (value.length > 3) {
				formatted += ') ' + value.substring(3, 6);
			}
			if (value.length > 6) {
				formatted += '-' + value.substring(6, 8);
			}
			if (value.length > 8) {
				formatted += '-' + value.substring(8, 10);
			}

			e.target.value = formatted;
		});
	},

	/**
	 * Инициализация полей ввода 4-значного кода
	 */
	initCodeInputs: function() {
		const inputs = document.querySelectorAll('.popup-auth__code-input');
		if (!inputs.length) return;

		inputs.forEach((input, index) => {
			// Ввод цифры - переход к следующему полю
			input.addEventListener('input', (e) => {
				const value = e.target.value.replace(/\D/g, '');
				e.target.value = value.slice(0, 1);

				if (value && index < inputs.length - 1) {
					inputs[index + 1].focus();
				}

				// Обновляем скрытое поле с полным кодом
				this.updateCodeValue();

				// Визуальная обратная связь
				if (value) {
					e.target.classList.add('filled');
					e.target.classList.remove('error');
				} else {
					e.target.classList.remove('filled');
				}
			});

			// Backspace - переход к предыдущему полю
			input.addEventListener('keydown', (e) => {
				if (e.key === 'Backspace' && !e.target.value && index > 0) {
					inputs[index - 1].focus();
				}
			});

			// Вставка из буфера
			input.addEventListener('paste', (e) => {
				e.preventDefault();
				const paste = (e.clipboardData || window.clipboardData).getData('text');
				const digits = paste.replace(/\D/g, '').slice(0, 4);

				digits.split('').forEach((digit, i) => {
					if (inputs[i]) {
						inputs[i].value = digit;
						inputs[i].classList.add('filled');
					}
				});

				// Фокус на следующее пустое поле или последнее
				const nextEmpty = Array.from(inputs).findIndex(inp => !inp.value);
				if (nextEmpty !== -1) {
					inputs[nextEmpty].focus();
				} else {
					inputs[inputs.length - 1].focus();
				}

				this.updateCodeValue();
			});
		});
	},

	/**
	 * Обновление скрытого поля с полным кодом
	 */
	updateCodeValue: function() {
		const inputs = document.querySelectorAll('.popup-auth__code-input');
		const codeValue = document.getElementById('auth-code-value');
		if (codeValue) {
			codeValue.value = Array.from(inputs).map(i => i.value).join('');
		}
	},

	/**
	 * Инициализация закрытия попапов
	 */
	initPopupClose: function() {
		// Закрытие по клику на кнопку
		document.querySelectorAll('.popup__close, .popup__btn-close').forEach(btn => {
			btn.addEventListener('click', () => {
				this.closePopups();
			});
		});

		// Закрытие по клику на фон
		document.querySelectorAll('.popup').forEach(popup => {
			popup.addEventListener('click', (e) => {
				if (e.target === popup || e.target.classList.contains('popup__wrapper')) {
					this.closePopups();
				}
			});
		});

		// Закрытие по Escape
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.closePopups();
			}
		});
	},

	/**
	 * Открытие попапа авторизации
	 */
	openAuthPopup: function(callback) {
		// Сохраняем callback для вызова после успешной авторизации
		if (callback) {
			this.onAuthSuccessCallback = callback;
		}

		const popup = document.getElementById('popup-auth');
		if (popup) {
			popup.classList.add('active');
			document.body.style.overflow = 'hidden';

			// Фокус на поле телефона
			setTimeout(() => {
				const phoneInput = document.getElementById('auth-phone');
				if (phoneInput) phoneInput.focus();
			}, 100);
		}
	},

	/**
	 * Открытие попапа ввода кода
	 */
	openCodePopup: function(phone, options) {
		options = options || {};
		const channel = options.channel || this.codeChannel || 'sms';
		const email = options.email || this.currentEmail || '';

		this.codeChannel = channel;
		if (email) this.currentEmail = email;

		// Закрываем попап телефона
		const phonePopup = document.getElementById('popup-auth');
		if (phonePopup) phonePopup.classList.remove('active');

		// Открываем попап кода
		const codePopup = document.getElementById('popup-auth-code');
		if (codePopup) {
			codePopup.classList.add('active');

			// Показываем куда отправлен код
			const phoneDisplay = document.getElementById('auth-code-phone');
			if (phoneDisplay) {
				if (channel === 'email' && email) {
					phoneDisplay.textContent = 'Код отправлен на ' + email;
				} else {
					phoneDisplay.textContent = 'Код отправлен на номер ' + this.formatPhone(phone);
				}
			}

			// Сохраняем телефон и email в скрытые поля
			const phoneValue = document.getElementById('auth-code-phone-value');
			if (phoneValue) phoneValue.value = phone;

			const emailValue = document.getElementById('auth-code-email-value');
			if (emailValue) emailValue.value = email;

			// Очищаем поля кода
			document.querySelectorAll('.popup-auth__code-input').forEach(input => {
				input.value = '';
				input.classList.remove('filled', 'error');
			});

			// Фокус на первое поле
			setTimeout(() => {
				const firstInput = document.querySelector('.popup-auth__code-input');
				if (firstInput) firstInput.focus();
			}, 100);

			// Запускаем таймер
			this.startCountdown();
		}
	},

	/**
	 * Закрытие всех попапов
	 */
	closePopups: function() {
		document.querySelectorAll('.popup').forEach(popup => {
			popup.classList.remove('active');
		});
		document.body.style.overflow = '';
		this.stopCountdown();
	},

	/**
	 * Вернуться к вводу телефона
	 */
	backToPhone: function() {
		const codePopup = document.getElementById('popup-auth-code');
		if (codePopup) codePopup.classList.remove('active');

		this.openAuthPopup();
		this.stopCountdown();
	},

	/**
	 * Форматирование номера телефона для отображения
	 */
	formatPhone: function(phone) {
		// Ожидаем формат 7XXXXXXXXXX
		const digits = phone.replace(/\D/g, '');
		if (digits.length === 11) {
			return '+' + digits[0] + ' (' + digits.slice(1, 4) + ') ' +
				digits.slice(4, 7) + '-' + digits.slice(7, 9) + '-' + digits.slice(9);
		}
		return '+' + phone;
	},

	/**
	 * Запуск обратного отсчёта для повторной отправки
	 */
	startCountdown: function() {
		this.stopCountdown();
		this.countdownValue = 60;

		const timer = document.getElementById('auth-code-timer');
		const resend = document.getElementById('auth-code-resend');
		const countdown = document.getElementById('auth-code-countdown');

		if (timer) timer.style.display = '';
		if (resend) resend.style.display = 'none';

		this.countdownTimer = setInterval(() => {
			this.countdownValue--;
			if (countdown) countdown.textContent = this.countdownValue;

			if (this.countdownValue <= 0) {
				this.stopCountdown();
				if (timer) timer.style.display = 'none';
				if (resend) resend.style.display = '';
			}
		}, 1000);
	},

	/**
	 * Остановка таймера
	 */
	stopCountdown: function() {
		if (this.countdownTimer) {
			clearInterval(this.countdownTimer);
			this.countdownTimer = null;
		}
	},

	/**
	 * Есть ли поле email в форме (режим auth_code_via_email)
	 */
	isEmailAuthMode: function() {
		return !!document.getElementById('auth-email');
	},

	/**
	 * Отправка кода на телефон или email
	 */
	sendCode: function(form) {
		const phoneInput = form.querySelector('[name="phone"]');
		const emailInput = form.querySelector('[name="email"]');
		const errorEl = document.getElementById('auth-phone-error');
		const submitBtn = form.querySelector('[type="submit"]');

		// Очищаем ошибку
		if (errorEl) errorEl.textContent = '';

		// Получаем номер (только цифры)
		let phone = phoneInput.value.replace(/\D/g, '');

		// Добавляем код страны если нужно
		if (phone.length === 10) {
			phone = '7' + phone;
		}

		// Валидация
		if (phone.length !== 11) {
			if (errorEl) errorEl.textContent = 'Введите корректный номер телефона';
			return;
		}

		let email = '';
		if (emailInput) {
			email = (emailInput.value || '').trim();
			if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
				if (errorEl) errorEl.textContent = 'Введите корректный email';
				return;
			}
		}

		this.currentPhone = phone;
		this.currentEmail = email;

		// Блокируем кнопку
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Отправка...';
		}

		// Отправляем запрос
		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'send_code');
		formData.append('phone', phone);
		if (email) {
			formData.append('email', email);
		}

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Получить код';
			}

			if (data.success) {
				this.openCodePopup(phone, {
					channel: data.channel || (email ? 'email' : 'sms'),
					email: data.email || email
				});
			} else {
				if (errorEl) errorEl.textContent = data.error || 'Ошибка отправки кода';
			}
		})
		.catch(error => {
			console.error('Auth error:', error);
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Получить код';
			}
			if (errorEl) errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Повторная отправка кода
	 */
	resendCode: function() {
		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'send_code');
		formData.append('phone', this.currentPhone);
		if (this.currentEmail) {
			formData.append('email', this.currentEmail);
		}

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				if (data.channel) this.codeChannel = data.channel;
				if (data.email) this.currentEmail = data.email;

				const phoneDisplay = document.getElementById('auth-code-phone');
				if (phoneDisplay) {
					if (this.codeChannel === 'email' && this.currentEmail) {
						phoneDisplay.textContent = 'Код отправлен на ' + this.currentEmail;
					} else {
						phoneDisplay.textContent = 'Код отправлен на номер ' + this.formatPhone(this.currentPhone);
					}
				}

				const emailValue = document.getElementById('auth-code-email-value');
				if (emailValue && this.currentEmail) emailValue.value = this.currentEmail;

				// Очищаем поля кода
				document.querySelectorAll('.popup-auth__code-input').forEach(input => {
					input.value = '';
					input.classList.remove('filled', 'error');
				});
				document.querySelector('.popup-auth__code-input')?.focus();

				// Перезапускаем таймер
				this.startCountdown();
			} else {
				const errorEl = document.getElementById('auth-code-error');
				if (errorEl) errorEl.textContent = data.error || 'Ошибка отправки кода';
			}
		})
		.catch(error => {
			console.error('Resend error:', error);
		});
	},

	/**
	 * Проверка кода
	 */
	verifyCode: function(form) {
		const codeValue = document.getElementById('auth-code-value');
		const phoneValue = document.getElementById('auth-code-phone-value');
		const emailValue = document.getElementById('auth-code-email-value');
		const errorEl = document.getElementById('auth-code-error');
		const submitBtn = form.querySelector('[type="submit"]');

		// Очищаем ошибку
		if (errorEl) errorEl.textContent = '';

		const code = codeValue ? codeValue.value : '';
		const phone = phoneValue ? phoneValue.value : this.currentPhone;
		const email = emailValue && emailValue.value ? emailValue.value : this.currentEmail;

		// Валидация
		if (code.length !== 4) {
			if (errorEl) errorEl.textContent = 'Введите 4-значный код';
			document.querySelectorAll('.popup-auth__code-input').forEach(input => {
				if (!input.value) input.classList.add('error');
			});
			return;
		}

		// Блокируем кнопку
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Проверка...';
		}

		// Отправляем запрос
		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'verify_code');
		formData.append('phone', phone);
		formData.append('code', code);
		if (email) {
			formData.append('email', email);
		}

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Войти';
			}

			if (data.success) {
				// Закрываем попап кода
				const codePopup = document.getElementById('popup-auth-code');
				if (codePopup) codePopup.classList.remove('active');

				// Если новый пользователь - показываем попап заполнения профиля
				if (data.is_new) {
					this.openProfileCompletePopup(data.client);
				} else {
					// Существующий пользователь - обновляем UI
					this.closePopups();
					this.onAuthSuccess(data.client);

					// Вызываем callback если есть
					if (this.onAuthSuccessCallback) {
						this.onAuthSuccessCallback(data.client);
						this.onAuthSuccessCallback = null;
					}
				}
			} else {
				if (errorEl) errorEl.textContent = data.error || 'Неверный код';

				// Визуальная обратная связь
				document.querySelectorAll('.popup-auth__code-input').forEach(input => {
					input.classList.add('error');
				});
			}
		})
		.catch(error => {
			console.error('Verify error:', error);
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Войти';
			}
			if (errorEl) errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Открыть попап заполнения профиля для новых клиентов
	 */
	openProfileCompletePopup: function(client) {
		// Удаляем предыдущий попап если есть
		const existing = document.getElementById('popup-profile-complete');
		if (existing) existing.remove();

		const popup = document.createElement('div');
		popup.className = 'popup popup-profile-complete';
		popup.id = 'popup-profile-complete';
		popup.innerHTML = `
			<div class="popup__wrapper">
				<div class="popup__container popup-profile-complete__container">
					<div class="popup-profile-complete__card">
						<div class="popup-profile-complete__header">
							<h3 class="popup-profile-complete__title">Добро пожаловать!</h3>
							<p class="popup-profile-complete__subtitle">Заполните, пожалуйста, данные профиля</p>
						</div>
						<div class="popup-profile-complete__content">
							<form id="profile-complete-form" onsubmit="Auth.saveProfileComplete(this); return false;">
								<div class="popup-profile-complete__row">
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Фамилия *</label>
										<input type="text" class="popup-profile-complete__input" name="str_lastname" placeholder="Иванов" required>
									</div>
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Имя *</label>
										<input type="text" class="popup-profile-complete__input" name="str_firstname" placeholder="Иван" required>
									</div>
								</div>
								<div class="popup-profile-complete__row">
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Отчество</label>
										<input type="text" class="popup-profile-complete__input" name="str_secondname" placeholder="Иванович">
									</div>
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Пол *</label>
										<select class="popup-profile-complete__select" name="sel_gender" required>
											<option value="">Выберите</option>
											<option value="мужской">Мужской</option>
											<option value="женский">Женский</option>
										</select>
									</div>
								</div>
								<div class="popup-profile-complete__row">
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Дата рождения *</label>
										<input type="text" class="popup-profile-complete__input popup-profile-complete__birthday" name="dte_birthday" placeholder="ДД.ММ.ГГГГ" required>
									</div>
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Email</label>
										<input type="email" class="popup-profile-complete__input" name="str_email" placeholder="example@mail.ru">
									</div>
								</div>
								<div class="popup-profile-complete__row">
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Город</label>
										<input type="text" class="popup-profile-complete__input" name="str_city" placeholder="Санкт-Петербург">
									</div>
									<div class="popup-profile-complete__field">
										<label class="popup-profile-complete__label">Предпочтительный способ связи *</label>
										<select class="popup-profile-complete__select" name="sel_contact_method" required>
											<option value="">Выберите</option>
											<option value="Telegram">Telegram</option>
											<option value="Max">Max (ВК Мессенджер)</option>
											<option value="Email">Email</option>
										</select>
									</div>
								</div>
								<div class="popup-profile-complete__checkboxes">
									<label class="popup-profile-complete__checkbox">
										<input type="checkbox" name="chk_privacy" value="1" required>
										<span>Соглашаюсь с <a href="/content/files/privacy_policy.pdf" target="_blank">положением об обработке персональных данных</a> *</span>
									</label>
									<label class="popup-profile-complete__checkbox">
										<input type="checkbox" name="chk_age" value="1" required>
										<span>Подтверждаю, что мне уже исполнилось 18 лет *</span>
									</label>
									<label class="popup-profile-complete__checkbox">
										<input type="checkbox" name="chk_subscribe" value="1">
										<span>Согласен на получение информационных рассылок о работе Центра</span>
									</label>
								</div>
								<div class="popup-profile-complete__error" id="profile-complete-error"></div>
								<div class="popup-profile-complete__actions">
									<button type="submit" class="popup-profile-complete__btn popup-profile-complete__btn--primary">Сохранить и продолжить</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		`;

		document.body.appendChild(popup);
		document.body.style.overflow = 'hidden';

		// Показываем попап
		setTimeout(() => popup.classList.add('active'), 10);

		// Инициализируем flatpickr для даты рождения
		const birthdayInput = popup.querySelector('.popup-profile-complete__birthday');
		if (birthdayInput && window.flatpickr) {
			flatpickr(birthdayInput, {
				dateFormat: 'd.m.Y',
				maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)), // Минимум 18 лет
				defaultDate: new Date(new Date().setFullYear(new Date().getFullYear() - 30)),
				locale: {
					firstDayOfWeek: 1
				}
			});
		}

		// Фокус на первое поле
		setTimeout(() => {
			const firstInput = popup.querySelector('input[name="lastname"]');
			if (firstInput) firstInput.focus();
		}, 100);
	},

	/**
	 * Сохранение данных профиля для нового клиента
	 */
	saveProfileComplete: function(form) {
		const errorEl = document.getElementById('profile-complete-error');
		const submitBtn = form.querySelector('[type="submit"]');

		// Очищаем ошибку
		if (errorEl) errorEl.textContent = '';

		// Валидация возраста (18+)
		const birthdayInput = form.querySelector('[name="birthday"]');
		if (birthdayInput && birthdayInput.value) {
			const parts = birthdayInput.value.split('.');
			if (parts.length === 3) {
				const birthday = new Date(parts[2], parts[1] - 1, parts[0]);
				const age = Math.floor((new Date() - birthday) / (365.25 * 24 * 60 * 60 * 1000));
				if (age < 18) {
					if (errorEl) errorEl.textContent = 'Вам должно быть не менее 18 лет';
					return;
				}
			}
		}

		// Собираем данные
		const formData = new FormData(form);
		formData.append('mid', this.profileModuleId);
		formData.append('action', 'save');

		// Преобразуем дату в формат БД
		if (birthdayInput && birthdayInput.value) {
			const parts = birthdayInput.value.split('.');
			if (parts.length === 3) {
				formData.set('birthday', parts[2] + '-' + parts[1] + '-' + parts[0]);
			}
		}

		// Блокируем кнопку
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Сохранение...';
		}

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Сохранить и продолжить';
			}

			if (data.success) {
				// Закрываем попап
				this.closePopups();

				// Обновляем UI
				const client = {
					firstname: formData.get('firstname'),
					lastname: formData.get('lastname')
				};
				this.onAuthSuccess(client);

				// Показываем сообщение
				this.showNotification('Профиль успешно заполнен!', 'success');

				// Вызываем callback если есть (для booking)
				if (this.onAuthSuccessCallback) {
					this.onAuthSuccessCallback(client);
					this.onAuthSuccessCallback = null;
				}
			} else {
				if (errorEl) errorEl.textContent = data.error || 'Ошибка сохранения';
			}
		})
		.catch(error => {
			console.error('Save profile error:', error);
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Сохранить и продолжить';
			}
			if (errorEl) errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Показать уведомление
	 */
	showNotification: function(message, type = 'success') {
		const notification = document.createElement('div');
		notification.className = 'auth-notification auth-notification--' + type;
		notification.textContent = message;
		notification.style.cssText = `
			position: fixed;
			top: 20px;
			right: 20px;
			background: ${type === 'success' ? '#6bb57f' : '#dc3545'};
			color: white;
			padding: 16px 24px;
			border-radius: 8px;
			font-size: 15px;
			z-index: 10000;
			box-shadow: 0 4px 12px rgba(0,0,0,0.15);
		`;

		document.body.appendChild(notification);

		setTimeout(() => {
			notification.style.opacity = '0';
			notification.style.transition = 'opacity 0.3s';
			setTimeout(() => notification.remove(), 300);
		}, 3000);
	},

	/**
	 * Проверка авторизации
	 */
	checkAuth: function(callback) {
		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'check_auth');

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success && data.authenticated) {
				this.onAuthSuccess(data.client);
			}
			if (callback) callback(data);
		})
		.catch(error => {
			console.error('Check auth error:', error);
			if (callback) callback({ success: false });
		});
	},

	/**
	 * Выход
	 */
	logout: function() {
		const formData = new FormData();
		formData.append('mid', this.moduleId);
		formData.append('action', 'logout');

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				this.onLogout();
			}
		})
		.catch(error => {
			console.error('Logout error:', error);
		});
	},

	/**
	 * Callback после успешной авторизации
	 */
	onAuthSuccess: function(client) {
		// Обновляем UI (кнопка входа -> кнопка профиля)
		const authBtn = document.querySelector('.header__auth-btn');
		if (authBtn && client) {
			authBtn.textContent = client.firstname || 'Профиль';
			authBtn.href = '/profile/';
			authBtn.onclick = null;
		}

		// Можно добавить событие для других компонентов
		document.dispatchEvent(new CustomEvent('authSuccess', { detail: client }));
	},

	/**
	 * Callback после выхода
	 */
	onLogout: function() {
		// Обновляем UI
		const authBtn = document.querySelector('.header__auth-btn');
		if (authBtn) {
			authBtn.textContent = 'Войти';
			authBtn.href = '#';
			authBtn.onclick = () => { Auth.openAuthPopup(); return false; };
		}

		// Перезагружаем страницу если на странице профиля
		if (window.location.pathname.indexOf('/profile') === 0) {
			window.location.href = '/';
		}

		document.dispatchEvent(new CustomEvent('authLogout'));
	}
};

// Автоинициализация при загрузке DOM
document.addEventListener('DOMContentLoaded', function() {
	Auth.init();
});

// Экспорт в глобальную область
window.Auth = Auth;
